<template>
  <b-row>
    <b-col sm="12" md="12">
      <b-card no-body>
        <b-card-header>
          <h5 class="float-left"><i class="fa fa-calculator"></i> VIP Level - Payment Option</h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="2">
              <label>Select Payment Method</label>
              <b-list-group>
                <b-list-group-item @click="selectMethod(val)" :variant="(val.Maintenance === 0) ? val.Color : 'secondary'" :active="selectedMethod.Name === val.Name" href="#" v-for="(val, key) in paymentMethod" :key="key"><i v-if="val.Maintenance === 1" class="fa fa-warning"></i> {{ val.Name }}</b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col sm="12" md="10" v-if="Object.keys(selectedMethod).length !== 0">
              <b-card no-body>
                <b-card-header>
                  <b-row>
                    <b-col sm="9">
                      <h5>{{ selectedMethod.Name }}</h5>
                      <template v-if="checkAccessPrivilege('Payment.Level.Options.Change')">
                        <template v-if="!showUpdateServiceTime">
                          <em>Daily Service Time: <span v-html="getServiceTime(selectedMethod)"></span></em> <br/>
                          <b-btn variant="success" class="mt-2 btn-sm" @click="showUpdateServiceTimeForm(selectedMethod)">Update Service Time</b-btn>
                        </template>
                        <template v-else>
                          <b-row>
                            <b-col sm="4" class="service-time">
                              <p-input v-model.trim="form.serviceTime.serviceFrom" name="serviceTime.serviceFrom" :handler="$v" :formData="form" type="time" />
                              <span class="mt-2 mx-2">TO</span>
                              <p-input v-model.trim="form.serviceTime.serviceTo" name="serviceTime.serviceTo" :handler="$v" :formData="form" type="time" />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col sm="4" class="mt-2">
                              <b-btn variant="success" class="btn-sm" @click="set24Hours()">Enable 24 Hours</b-btn>
                              <b-btn variant="success" class="btn-sm" @click="updateServiceTime()">Save</b-btn>
                              <b-btn variant="danger" class="btn-sm" @click="closeUpdateServiceTimeForm()">Cancel</b-btn>
                            </b-col>
                          </b-row>
                        </template>
                      </template>
                    </b-col>
                    <b-col sm="3">
                      <div class="float-right" style="width: 300px">
                        <strong>Payment Status</strong>
                        <b-form-select v-if="checkAccessPrivilege('Payment.Level.Options.Change')" id="maintenanceStatus" :plain="true" :options="maintenanceOption" v-model="maintenanceStatus" text-field="label" value-field="key" @change="switchMaintenance()"></b-form-select>
                        <template v-else>
                          <b-badge v-if="selectedMethod.Maintenance === 0" variant="success">Enabled</b-badge>
                          <b-badge v-if="selectedMethod.Maintenance === 1" variant="danger">Maintenance</b-badge>
                        </template>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-header>
                <b-card-body>
                  <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                    <template v-slot:cell(Status)="data">
                      <p-dropdown v-if="data.item._editable" v-model.trim="form.vipLevel.status" class="dropdown-select" name="vipLevel.status" :handler="$v" :formData="form" :options="statusOption" textKey="key" textValue="label"/>
                      <template v-else>
                        <b-badge variant="success" v-if="data.item.Status === 1">Enable</b-badge>
                        <b-badge variant="danger" v-else-if="data.item.Status === 0">Disable</b-badge>
                      </template>
                    </template>
                    <template v-slot:cell(Action)="data" v-if="checkAccessPrivilege('Payment.Level.Options.Change')">
                      <template v-if="data.item._editable">
                        <b-btn class="btn-sm" @click="updateStatus(data.item)" variant="success"><i class="fa fa-check"></i> Save</b-btn>
                        <b-btn class="btn-sm" @click="cancelUpdateStatus(data.item)" variant="danger"><i class="fa fa-close"></i> Cancel</b-btn>
                      </template>
                      <b-btn v-else @click="showUpdateStatus(data.item)" class="btn-sm" variant="danger"><i class="fa fa-pencil"></i> Edit</b-btn>
                    </template>
                  </b-table>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import VueNotifications from 'vue-notifications'
import {PInput, PDropdown} from '../../../../../components'
import {Events} from '../../../../../events.js'
const {required} = require('vuelidate/lib/validators')
export default {
  name: 'vip-payment-option-list-view',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showUpdateServiceTime: false,
      updateData: {},
      items: [],
      paymentMethod: [],
      selectedMethod: {},
      fields: [
        {key: 'Name', label: 'VIP Level'},
        {key: 'Status', label: 'Status'},
        {key: 'Action', label: 'Action'}
      ],
      form: {
        serviceTime: {
          serviceFrom: '',
          serviceTo: ''
        },
        vipLevel: {
          paymentId: '',
          levelId: '',
          status: null
        }
      },
      statusOption: [
        {key: 1, label: 'Enable'},
        {key: 0, label: 'Disable'}
      ],
      maintenanceStatus: 0,
      maintenanceOption: [
        {key: '0', label: 'Enabled'},
        {key: '1', label: 'Under Maintenance'}
      ]
    }
  },
  components: {
    PInput,
    PDropdown
  },
  validations: {
    form: {
      serviceTime: {
        serviceFrom: {},
        serviceTo: {}
      },
      vipLevel: {
        paymentId: { required },
        levelId: { required },
        status: { required }
      }
    }
  },
  methods: {
    async selectMethod (val) {
      this.selectedMethod = val
      this.maintenanceStatus = val.Maintenance
      this.getVipMapList(val.Id)
      this.resetServiceTime()
    },
    resetServiceTime () {
      this.showUpdateServiceTime = false
      this.form.serviceTime.from = ''
      this.form.serviceTime.to = ''
      this.$v.form.serviceTime.$reset()
    },
    async getVipMapList (paymentId) {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.post(this.API_ENDPOINT + '/payment/withdraw/viplevel/vip', { paymentId: paymentId }, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.list
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async getPaymentMethodList () {
      try {
        let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/paymentMethod/getList?type=2', { headers: { 'Content-Type': 'application/json' } })
        this.paymentMethod = data.list
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async updateStatus (item) {
      try {
        this.$v.form.vipLevel.$touch()
        if (this.$v.form.vipLevel.$error) {
          return true
        }
        Events.$emit('loader')
        let requestBody = {
          paymentId: this.form.vipLevel.paymentId,
          levelId: this.form.vipLevel.levelId,
          status: this.form.vipLevel.status
        }
        await this.$http.post(this.API_ENDPOINT + '/payment/withdraw/viplevel/changestatus', requestBody, { headers: { 'Content-Type': 'application/json' } })
        await this.getVipMapList(this.form.vipLevel.paymentId)
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Status Update Successfully')
        this.cancelUpdateStatus(item)
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async switchMaintenance () {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/payment/paymentMethod/maintenance', {
          paymentId: this.selectedMethod.Id,
          status: this.maintenanceStatus
        })
        this.getPaymentMethodList()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Payment Maintenace Status Changed Successfully.')
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    set24Hours () {
      this.form.serviceTime.serviceFrom = ''
      this.form.serviceTime.serviceTo = ''
      this.updateServiceTime()
    },
    async updateServiceTime () {
      try {
        Events.$emit('loader')
        const payload = {
          paymentId: this.selectedMethod.Id,
          from: this.form.serviceTime.serviceFrom,
          to: this.form.serviceTime.serviceTo
        }
        await this.$http.post(this.API_ENDPOINT + '/payment/paymentMethod/service-time/update', payload)
        this.selectedMethod.ServiceTimeFrom = this.form.serviceTime.serviceFrom
        this.selectedMethod.ServiceTimeTo = this.form.serviceTime.serviceTo
        this.resetServiceTime()
      } catch (err) {
        if (err.response.data.code === 'params.service.range.required') {
          Events.$emit('alert', VueNotifications.types.error, 'Error', err.response.data.msg)
        } else {
          console.log(err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      } finally {
        Events.$emit('loader')
      }
    },
    showUpdateServiceTimeForm (item) {
      this.showUpdateServiceTime = true
      this.form.serviceTime.serviceFrom = item.ServiceTimeFrom
      this.form.serviceTime.serviceTo = item.ServiceTimeTo
    },
    closeUpdateServiceTimeForm () {
      this.showUpdateServiceTime = false
      this.resetServiceTime()
    },
    getServiceTime (method) {
      if (!method.ServiceTimeFrom && !method.ServiceTimeTo) {
        return '24 Hours'
      }
      let from = moment(moment().format(`YYYY-MM-DD ${method.ServiceTimeFrom}`))
      let to = moment(moment().format(`YYYY-MM-DD ${method.ServiceTimeTo}`))
      let isNextDay = ''
      if (to.isBefore(from)) {
        isNextDay = 'Next Day'
      }
      return `${from.format('hh:mm A')} - <span style="color:red">${isNextDay}</span> ${to.format('hh:mm A')} (GMT+8)`
    },
    showUpdateStatus (item) {
      this.$set(item, '_editable', true)
      this.form.vipLevel.paymentId = this.selectedMethod.Id
      this.form.vipLevel.levelId = item.Id
      this.form.vipLevel.status = item.Status
    },
    cancelUpdateStatus (item) {
      this.$delete(item, '_editable')
      this.form.vipLevel.paymentId = ''
      this.form.vipLevel.levelId = ''
      this.form.vipLevel.status = null
    },
    checkAccessPrivilege (module) {
      if (!module) return true
      return this.PRIVILEGE.includes(module)
    }
  },
  created () {
    this.getPaymentMethodList()
  }
}
</script>

<style scoped>
.service-time {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/views/payment/viplevelwithdraw/viplevelpayment/views/ListView.vue